import { Link } from 'react-router-dom';

interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  rating: number;
  views: number;
  chapters: number;
  updateDate: string;
}

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formatViews = (views: number) => {
    if (views >= 10000) {
      return (views / 10000).toFixed(1) + '万';
    }
    return views.toString();
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[5/7] mb-3 bg-background-100">
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          title={`${comic.title} - 韩漫屋韩国漫画在线`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
            {comic.rating}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded-md">
            {comic.chapters}话
          </span>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500">{comic.author}</p>
      <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-400">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line" />
          {formatViews(comic.views)}
        </span>
        <span>{comic.updateDate}</span>
      </div>
    </Link>
  );
}